import { render, staticRenderFns } from "./FindRecords.vue?vue&type=template&id=1460da53&scoped=true"
import script from "./FindRecords.vue?vue&type=script&lang=js"
export * from "./FindRecords.vue?vue&type=script&lang=js"
import style0 from "./FindRecords.vue?vue&type=style&index=0&id=1460da53&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1460da53",
  null
  
)

export default component.exports